import React, { useState, useEffect } from "react";
import { Navbar, Nav, NavDropdown, Container, Offcanvas } from "react-bootstrap";
import logo from "../assets/Logopuja.png";
import { NavLink } from "react-router-dom";
import { FaBars, FaHome, FaInfoCircle, FaPrayingHands, FaConciergeBell, FaUserTie, FaEnvelope, FaSearch, FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import "../../src/components/styles/Header.css";
import axios from "axios";
function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [searchCity, setSearchCity] = useState("");
const [searchResults, setSearchResults] = useState([]);
const [showResults, setShowResults] = useState(false);
 
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  const searchCities = async (cityName) => {

  if (!cityName.trim()) {
    setSearchResults([]);
    setShowResults(false);
    return;
  }

  try {

    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/city/search/`,
      {
        params: {
          q: cityName
        }
      }
    );

    const cityList =
      response.data?.data?.city_list || [];

    setSearchResults(cityList);
    setShowResults(cityList.length > 0);

  } catch (err) {

    console.error(
      "City Search Error:",
      err
    );

    setSearchResults([]);
    setShowResults(false);

  }

};



const handleCitySelect = (city) => {

  localStorage.setItem(
    "selectedCity",
    city.city_name
  );

  localStorage.setItem(
    "selectedCityId",
    city.id
  );

  localStorage.setItem(
    "selectedState",
    city.state_name
  );

  localStorage.setItem(
    "selectedStateId",
    city.state_id
  );

  localStorage.setItem(
    "selectedCountry",
    city.country_name
  );

  localStorage.setItem(
    "selectedCountryId",
    city.country_id
  );

  setSearchCity(city.city_name);

  setShowResults(false);

  window.location.reload();
};

  return (
    <div className="container">



<div className="container   top-bar  d-block d-md-none fixed-navbar">
  <div className=" d-flex justify-content-between ps-3 pe-3">
    <div className="text-white">Talk to Astrologers</div>
    <div class="dropdown">

  <i class="fa-solid fa-caret-down m-0 p-0 "  id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false"></i>

  <ul class="dropdown-menu w-100 bg-light border rounded">
  <li>
    <button class="dropdown-item text-dark" type="button">Action</button>
  </li>
  <li>
    <button class="dropdown-item text-dark" type="button">Another action</button>
  </li>
  <li>
    <button class="dropdown-item text-dark" type="button">Something else here</button>
  </li>
</ul>
</div>
  </div>
</div>
      {/* Top Bar - Hides on Scroll */}

      <nav className={` ttopbarnone top-bar ${isScrolled ? "hide-top-bar" : ""}`}>
        <div className="container d-flex flex-wrap justify-content-between align-items-center">
          <span className="text-dark">Talk to Astrologers: +000 123 456789</span>
          <div className="d-flex gap-3 align-items-center">
            <a href="mailto:info@ezpujapath.com" className="text-dark text-decoration-none">
              info@ezpujapath.com
            </a>
            <span className="text-dark">| Follow us on</span>

            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="text-dark">
              <FaFacebookF className="fs-5 cursor-pointer" />
            </a>

            <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="text-dark">
              <FaInstagram className="fs-5 cursor-pointer" />
            </a>

            <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer" className="text-dark">
              <FaYoutube className="fs-5 cursor-pointer" />
            </a>
          </div>

        </div>
      </nav>







      {/* Sticky Navbar */}
      <Navbar expand="lg" className={`shadow  px-0 mt-lg-0 mt-4 nav-position ${isScrolled ? "fixed-navbar" : ""}`}>
        <Container fluid className="d-flex justify-content-between align-items-center container ">

          {/* Logo */}
          <Navbar.Brand href="/" className="me-2 order-lg-0 order-3">
            <img src={logo} alt="Ez Puja Path" className="img-fluid" style={{ height: "80px" }} />
          </Navbar.Brand>

          {/* Search Bar - Mobile View */}
          <div className="d-flex d-lg-none flex-grow-1 mx-2 position-relative order-lg-2 order-2" style={{ width: '50%' }}>
          <FaSearch className="position-absolute ms-3 me-3 top-50 translate-middle-y text-muted " />

            <input
              type="text"
              placeholder="     Search..."
              className="form-control rounded-pill px-4 pe-5"
              style={{ paddingRight: "35px",backgroundColor: '#ECE6F0' }}
            />
          </div>

          {/* Mobile Sidebar Toggle */}
          <button className="btn fs-1 d-lg-none order-0 " style={{marginTop:'-11px',outline:'none'}} onClick={() => setShowSidebar(true)}>
            <FaBars />
          </button>
            

          {/* Desktop Navigation */}
          <Navbar.Collapse id="navbarScroll" className="justify-content-between d-none d-lg-flex order-lg-3 order-0 ">

            {/* Search Bar - Desktop */}
           <div
  className="position-relative search-bar"
  style={{ width: "280px" }}
>

  <input
    type="text"
    placeholder={
      localStorage.getItem("selectedCity")
        || "Search City..."
    }
    className="form-control rounded-pill px-4"
    style={{
      backgroundColor: "#ECE6F0"
    }}
    value={searchCity}
    onChange={(e) => {

      setSearchCity(
        e.target.value
      );

      searchCities(
        e.target.value
      );

    }}
  />

  <button
    className="position-absolute end-0 top-50 translate-middle-y btn btn-link text-dark"
  >
    <FaSearch />
  </button>

  {showResults && (
    <div
      className="position-absolute bg-white shadow w-100 mt-1 rounded"
      style={{
        zIndex: 9999,
        maxHeight: "250px",
        overflowY: "auto"
      }}
    >

      {searchResults.map(
        (city) => (

          <div
            key={city.id}
            className="p-2 border-bottom"
            style={{
              cursor: "pointer"
            }}
            onClick={() =>
              handleCitySelect(
                city
              )
            }
          >
            <strong>
              {
                city.city_name
              }
            </strong>

            <br />

            <small>
              {
                city.state_name
              }
              ,
              {
                city.country_name
              }
            </small>

          </div>

        )
      )}

    </div>
  )}

</div>

            {/* Navigation Links */}
            <Nav className="mx-auto gap-4">
  <Nav.Link as={NavLink} to="/" className="nav-text">
  Home
</Nav.Link>

<Nav.Link as={NavLink} to="/about" className="nav-text">
  About Us
</Nav.Link>

<Nav.Link as={NavLink} to="/epuja" className="nav-text">
  e-Puja
</Nav.Link>

<Nav.Link as={NavLink} to="/puja-service" className="nav-text">
  Puja Service
</Nav.Link>

<Nav.Link as={NavLink} to="/pandit" className="nav-text">
  Know Your Pandit
</Nav.Link>

<Nav.Link as={NavLink} to="/contact" className="nav-text">
  Contact Us
</Nav.Link>
            </Nav>

            {/* Language Selector */}
            {/* <div className="d-flex align-items-center gap-2">
              <img src="https://flagcdn.com/w40/gb.png" alt="English" className="img-fluid" style={{ height: "15px" }} />
              <NavDropdown title="English" id="navbarScrollingDropdown" className="fw-bold text-dark">
                <NavDropdown.Item href="#">English</NavDropdown.Item>
                <NavDropdown.Item href="#">Hindi</NavDropdown.Item>
                <NavDropdown.Item href="#">Bengali</NavDropdown.Item>
              </NavDropdown>
            </div> */}
          </Navbar.Collapse>
        </Container>
      </Navbar>


      {/* Mobile Sidebar */}



      <Offcanvas show={showSidebar} onHide={() => setShowSidebar(false)} placement="start" style={{ width: "80%" }} backdropClassName="custom-backdrop">
        <Offcanvas.Header  style={{ borderBottom: '1px solid #aaa' }}>
          <div>
            <Offcanvas.Title>
              <img src={logo} alt="Ez Puja Path" className="img-fluid" style={{ height: "80px" }} />
            </Offcanvas.Title>
            <p style={{ fontSize: '20px', fontWeight: '600', margin: '0px' }}>Ez Puja Path</p>
            <p style={{ fontSize: '16px', fontWeight: '400', margin: '0px',color:'#aaa' }}>Your Trusted Online Puja Partner</p>
          </div>

        </Offcanvas.Header>
        <Offcanvas.Body onClick={() => setShowSidebar(false)}>
          <Nav className="flex-column">
<Nav.Link
  as={NavLink}
  to="/"
  className="nav-textmobileview"
>
  <FaHome className="me-2 fs-1" /> Home
</Nav.Link>

<Nav.Link
  as={NavLink}
  to="/about"
  className="nav-textmobileview"
>
  <FaInfoCircle className="me-2 fs-1" /> About Us
</Nav.Link>

<Nav.Link
  as={NavLink}
  to="/epuja"
  className="nav-textmobileview"
>
  <FaPrayingHands className="me-2 fs-1" /> e-Puja
</Nav.Link>

<Nav.Link
  as={NavLink}
  to="/puja-service"
  className="nav-textmobileview"
>
  <FaConciergeBell className="me-2 fs-1" /> Puja Service
</Nav.Link>

<Nav.Link
  as={NavLink}
  to="/pandit"
  className="nav-textmobileview"
>
  <FaUserTie className="me-2 fs-1" /> Know Your Pandit
</Nav.Link>

<Nav.Link
  as={NavLink}
  to="/contact"
  className="nav-textmobileview"
>
  <FaEnvelope className="me-2 fs-1" /> Contact Us
</Nav.Link>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}

export default Header;



// import React, { useState, useEffect } from "react";
// import { Navbar, Nav, NavDropdown, Container, Offcanvas } from "react-bootstrap";
// import logo from "../assets/Logopuja.png";
// import { FaSearch, FaFacebookF, FaInstagram, FaYoutube, FaBars, FaHome, FaInfoCircle, FaPrayingHands, FaConciergeBell, FaUserTie, FaEnvelope } from "react-icons/fa";
// import "../../src/components/styles/Header.css";

// function Header() {
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [showSidebar, setShowSidebar] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 50) {
//         setIsScrolled(true);
//       } else {
//         setIsScrolled(false);
//       }
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   return (
//     <div>
//       {/* Top Bar - Hides on Scroll */}
//       <nav className={` ttopbarnone top-bar ${isScrolled ? "hide-top-bar" : ""}`}>
//         <div className="container d-flex flex-wrap justify-content-between align-items-center">
//           <span className="text-dark">Talk to Astrologers: +000 123 456789</span>
//           <div className="d-flex gap-3 align-items-center">
//             <a href="mailto:info@ezpujapath.com" className="text-dark text-decoration-none">
//               info@ezpujapath.com
//             </a>
//             <span className="text-dark">| Follow us on</span>

//             <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="text-dark">
//               <FaFacebookF className="fs-5 cursor-pointer" />
//             </a>

//             <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="text-dark">
//               <FaInstagram className="fs-5 cursor-pointer" />
//             </a>

//             <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer" className="text-dark">
//               <FaYoutube className="fs-5 cursor-pointer" />
//             </a>
//           </div>
//         </div>
//       </nav>

//       {/* Sticky Navbar */}
//       <Navbar expand="lg" className={`shadow py-2 px-0 nav-position ${isScrolled ? "fixed-navbar" : ""}`}>
//         <Container fluid className="d-flex justify-content-between align-items-center">
//           <Navbar.Brand href="/" className="me-2">
//             <img src={logo} alt="Ez Puja Path" className="img-fluid" style={{ height: "80px" }} />
//           </Navbar.Brand>
//           {/* Search Bar - Mobile View */}
//           <div className="d-flex d-lg-none flex-grow-1 mx-2 position-relative" style={{ width: '50%' }}>
//             <input
//               type="text"
//               placeholder="Search..."
//               className="form-control rounded-pill px-4"
//               style={{ paddingRight: "35px" }}
//             />
//             <FaSearch className="position-absolute end-0 me-3 top-50 translate-middle-y text-muted" />
//           </div>
//           <button className="btn btn-dark d-lg-none" onClick={() => setShowSidebar(true)}>
//             <FaBars />
//           </button>
//         </Container>
//       </Navbar>

//       {/* Mobile Sidebar */}
//       <Offcanvas show={showSidebar} onHide={() => setShowSidebar(false)} placement="start" style={{ width: "80%" }} backdropClassName="custom-backdrop">
//         <Offcanvas.Header closeButton style={{ borderBottom: '1px solid #aaa' }}>
//           <Offcanvas.Title>
//             <img src={logo} alt="Ez Puja Path" className="img-fluid" style={{ height: "80px" }} />
//             <p style={{fontSize:'20px',fontWeight:'600',margin:'0px'}}>Ez Puja Path</p>
//             <p style={{fontSize:'17px',fontWeight:'400',margin:'0px'}}>Your Trusted Online Puja Partner</p>
//           </Offcanvas.Title>
//         </Offcanvas.Header>
//         <Offcanvas.Body>
//           <Nav className="flex-column">
//             <Nav.Link href="/" className="nav-text" onClick={() => setShowSidebar(false)}><FaHome className="me-2" /> Home</Nav.Link>
//             <Nav.Link href="/about" className="nav-text" onClick={() => setShowSidebar(false)}><FaInfoCircle className="me-2" /> About Us</Nav.Link>
//             <Nav.Link href="/epuja" className="nav-text" onClick={() => setShowSidebar(false)}><FaPrayingHands className="me-2" /> e-Puja</Nav.Link>
//             <Nav.Link href="/puja-service" className="nav-text" onClick={() => setShowSidebar(false)}><FaConciergeBell className="me-2" /> Puja Service</Nav.Link>
//             <Nav.Link href="/pandit" className="nav-text" onClick={() => setShowSidebar(false)}><FaUserTie className="me-2" /> Know Your Pandit</Nav.Link>
//             <Nav.Link href="/contact" className="nav-text" onClick={() => setShowSidebar(false)}><FaEnvelope className="me-2" /> Contact Us</Nav.Link>
//           </Nav>
//         </Offcanvas.Body>
//       </Offcanvas>
//     </div>
//   );
// }

// export default Header;
